import React from "react";
import { getRouletteNumberAsset } from "./rouletteNumberAssets";

function RouletteLatestField({ latestResults }) {
  const results = Array.isArray(latestResults)
    ? latestResults.slice(0, 8)
    : [];

  return (
    <div className="roulette-croupier-latest" aria-label="Latest roulette results">
      <span className="roulette-croupier-latest-label">LATEST</span>

      <span className="roulette-croupier-latest-track">
        {results.map((result, index) => {
          const src = getRouletteNumberAsset(result);

          return (
            <span
              className="roulette-croupier-latest-item"
              key={`${result}-${index}`}
              title={String(result)}
            >
              {src && (
                <img
                  src={src}
                  alt={`Roulette result ${result}`}
                  draggable="false"
                />
              )}
            </span>
          );
        })}
      </span>
    </div>
  );
}

export default RouletteLatestField;
